import React, { Component } from 'react';
import AWS from 'aws-sdk';
// import {TextFieldForm, SelectFieldForm} from './FieldForms';
import './basicforms.css';

class InfoForm extends Component {
  constructor(props) {
    super(props);

    this.state ={
      email: this.props.authData.attributes.email,
      company: '',
      fullName: '',
      address: ''
    }

    this.handleChange = this.handleChange.bind(this);
    //this.handleChangeCheck = this.handleChangeCheck.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.buildValidUpdate = this.buildValidUpdate.bind(this);
  }

  handleChange(event) {
    this.setState({[event.target.name]: event.target.value});
  }

  // handleChangeCheck(event) {
  //   this.setState({[event.target.name]: event.target.checked});
  // }

  componentDidMount() {
    this.props.auth.currentCredentials({
      bypassCache: false  // Optional, By default is false. If set to true, this call will send a request to Cognito to get the latest user data
    }).then(credentials => {
      const dynamodb = new AWS.DynamoDB.DocumentClient({
        region: 'us-east-1',
        credentials: this.props.auth.essentialCredentials(credentials)
      });
      var params = {
        ExpressionAttributeValues: {
          ':id': this.props.authData.attributes.sub,
        },
        ExpressionAttributeNames: {
          '#id': 'userId',
        },
        KeyConditionExpression: '#id = :id' ,
        TableName: 'UserInfo'
      };

      dynamodb.query(params, (err, data) => {
        if (err) {
          console.log(err);
          return null;
        } else {
          this.setState(
            data.Items[0]
          );
        }
      });

    })
    .catch(err => console.log(err));
  }

  handleSubmit(event) {
    event.preventDefault();
    this.props.auth.currentCredentials()
      .then(credentials => {
        //console.log(credentials);
        const dynamodb = new AWS.DynamoDB.DocumentClient({
          region: 'us-east-1',
          credentials: this.props.auth.essentialCredentials(credentials)
        });

        var validParams = this.buildValidUpdate();

        var params = {
          ExpressionAttributeValues: validParams.attributeValues,
          Key: {
            userId : this.props.authData.attributes.sub
          },
          UpdateExpression: validParams.updateExpression,
          // ExpressionAttributeNames: {
          //   '#id': 'farmId',
          // },
          // KeyConditionExpression: '#id = :id' ,
          TableName: 'UserInfo'
        };

        dynamodb.update(params, (error, data) => {
          if (error) {
            console.log(error);
            return null;
          } else {
            console.log('Wrote data to DynamoDB');
            console.log (data);
            alert("Dados atualizados com sucesso!");
          }
        });
    });
  }

  buildValidUpdate() {
    //Checks if fields are non-empty strings to build update strings
    //for use in params
    //AWS DynamoDB doesn't accept empty strings
    // Add more validation in the future
    var validFields = 0;
    var updateExpression = '';
    var attributeValues = {};
    if (this.state.company !== '') {
      updateExpression = 'company = :company';
      attributeValues[':company'] = this.state.company;
      validFields++;
    }
    if (this.state.fullName !== '') {
      if (validFields) {
        updateExpression += ', '
      }
      updateExpression += 'fullName = :fullName';
      attributeValues[':fullName'] = this.state.fullName;
      validFields++;
    }
    if (this.state.address !== '') {
      if (validFields) {
        updateExpression += ', '
      }
      updateExpression += 'address = :address';
      attributeValues[':address'] = this.state.address;
      validFields++;
    }
    if (validFields) {
      updateExpression = 'set ' + updateExpression;
    }
    var validParams = {
      'updateExpression': updateExpression,
      'attributeValues': attributeValues
    }
    return (validParams);
  }

  render() {
    //const userTypes = ["Grower","Roaster","Coop","Other coffee enthusiast"];

    return (
      <div className='basicforms form_container'>
        <p className='pagetitle'>Meus Dados</p>
        <form className='basicforms' onSubmit={this.handleSubmit}>
    			<div className='form_container' >
    				<div className="row">
    					<div className="col-25">
    						<label>email</label>
    					</div>
    					<div className="col-50">
    						<input type="email" name="email" disabled value={this.state.email} onChange={this.handleChange} />
    					</div>
    				</div>

            <div className="row">
			        <div className="col-25">
				        <label>Full Name</label>
			        </div>
			        <div className="col-50">
				        <input type="text" name="fullName" value={this.state.fullName} onChange={this.handleChange} />
			        </div>
		        </div>
            <div className="row">
    					<div className="col-25">
    						<label>Address</label>
    					</div>
    					<div className="col-50">
    						<input type="text" name="address" value={this.state.address} onChange={this.handleChange} />
    					</div>
    				</div>
    				<div className="row">
  				    <div className="col-75">
  					    <input type="submit" value="Submit"/>
  				    </div>
		        </div>
    			</div>
        </form>
      </div>
    );
  }
}

export default InfoForm;



// WEBPACK FOOTER //
// ./src/components/InfoForm.js